module.exports = __webpack_public_path__ + "static/clients-hero-image-82101f39fb0e11115ba99b700063d5d5.png";